import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {FunnelService} from "../services/funnel.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-consent-modal',
  templateUrl: './consent-modal.component.html',
  styleUrls: ['./consent-modal.component.scss']
})
export class ConsentModalComponent {

  constructor(
    private _modalService: BsModalService,
  )
  {}

  closeModal(){
    this._modalService.hide();
  }

}
